import React from 'react'

import { Caption } from '@/shared/components/typography/index'

export interface IsSaleButtonProps {
  text: string
  isActive: boolean
  onClick: () => void
}

const IsSaleButton = ({ text, isActive, onClick }: IsSaleButtonProps) => {
  return (
    <button
      className={`rounded-[20px] px-[8px] py-[3px] ${
        isActive ? 'border border-[#263238] bg-main-090 text-white' : 'border bg-transparent text-text-090'
      }`}
      onClick={onClick}
    >
      <Caption level="caption2">{text}</Caption>
    </button>
  )
}

export default IsSaleButton
